module.exports = __webpack_public_path__ + "static/media/it.71cece93.svg";